import React, {ReactElement, useEffect, useState} from 'react'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

interface GetProps {
  title: string
  buttons?: React.JSX.Element
  helpInfo?: ReactElement | string
}

export default function BreadcrumMenu({title, buttons, helpInfo}: GetProps) {
  return (
    <div className="breadcrumb__area">
      <div className="breadcrumb__wrapper mb-35">
        <div className="breadcrumb__main">
          <div className="breadcrumb__inner">
            <div className="breadcrumb__icon">
              <i className="flaticon-home"></i>
            </div>
            <div className="breadcrumb__menu">
              <nav>
                <ul>
                  <li></li>
                  <li className="active">
                    <span> {title} </span>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <HelperInfo helpInfo={helpInfo} />
          {buttons}
        </div>
      </div>
    </div>
  )
}

const HelperInfo = (props: {helpInfo?: ReactElement | string}) => {
  const {helpInfo} = props
  const {t} = useI18n()
  const [open, setOpen] = useState<boolean>(false)
  const containerRef = React.useRef<HTMLDivElement>(null)
  const toggleOpen = () => {
    setOpen((current) => !current)
  }

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (!helpInfo) return null

  return (
    <Wrapper ref={containerRef}>
      <StyledButton type="button" className="input__btn" onClick={toggleOpen}>
        {t('common.help')}
      </StyledButton>

      {open && <PopupHolder>{helpInfo}</PopupHolder>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`

const StyledButton = styled.button`
  color: #fff;
  padding: 8px 18px;
  font-size: 14px;
  border-radius: 25px;
`

const PopupHolder = styled.div`
  position: absolute;
  top: 65px;
  right: 0;
  background: #fff;
  border-radius: 6px;
  padding: 18px;
  max-height: calc(80vh - 180px);
  max-width: 80vw;
  width: 500px;
  overflow: auto;
  z-index: 1000;

  /* Gradient border that respects border-radius */
  border: 3px solid transparent;
  background-image: linear-gradient(wheat, wheat), var(--clr-gradient-14);
  background-origin: border-box;
  background-clip: padding-box, border-box;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
`
